import { client } from "api";
import { User, UserRole } from "features/auth/types/user";

export type GetAllUsersRequest =
  | {
      roles?: UserRole[] | null;
      departmentIds?: number[] | null;
      officeIds?: number[] | null;
      inactive?: boolean | null;
    }
  | undefined;

export type GetAllUsersResponse = User[];

export const getAllUsers = (request: GetAllUsersRequest): Promise<GetAllUsersResponse> =>
  client
    .get<GetAllUsersResponse>(`/user/list`, {
      params: {
        roles: request?.roles?.join(","),
        departmentIds: request?.departmentIds?.join(","),
        officeIds: request?.officeIds?.join(","),
        inactive: request?.inactive,
      },
    })
    .then((res) => res.data);
